// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SY7R","right":"styles_right__1YIhp"};